import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { autobind } from 'core-decorators';

class ClaimSuccessModalStore extends BaseModalStore {
  /**
   * 账号 owner 变化时强制关闭活跃展示；非活跃重置没有全局
   * 样式副作用，这里也不保留任何业务事实。
   * @returns {void}
   */
  resetForOwnerChange() {
    if (this.isActive || this.isOpen) {
      this.onClickClose();
    }
  }

  /** 仅关闭展示状态；已领奖励的归属保留在页面 store。 */
  @autobind
  requestClose() {
    this.onClickClose();
    return true;
  }
}

export default ClaimSuccessModalStore;
